import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { WatchWrapper, NoFeedWrapper } from '../medialinks.style';
import buildTvUrl from '@gameday/utils/buildTvUrl';
import Link from '@mlb/react-patterns/components/Link/link';
import useTracking from '@gameday/utils/hooks/useTracking';
import { useTranslate } from '@gameday/utils/hooks/useTranslate';
import { getMediaLinksState } from '../store/selectors/getMediaLinks';

const getWatchList = (tv, tz, gamePk, dateTime, translate, gameContext, language, partnerBroadcaster) => {
    const feeds = {};
    const mediaOffText = translate('gameday_media_off', 'No active feeds available');
    const { title = '', list = [] } = tv;
    const titleKey = 'gameday_media_tv_' + title?.replace(/[\W_]+/g, ' ')?.toLowerCase();
    const mediaItem = list?.[0] || {};
    const { mediaState } = mediaItem;

    const tvTitle = translate(titleKey, gameContext === 'milb' ? 'MiLB.TV' : 'MLB.TV');

    if (!!partnerBroadcaster && mediaState === 'MEDIA_ON') {
        const { shortTextLabelKey, url } = partnerBroadcaster;
        feeds.directive = '';
        feeds.all = [{
            text: translate(shortTextLabelKey, tvTitle),
            url
        }];
    } else if (mediaState === 'MEDIA_ON' || mediaState === 'MEDIA_ARCHIVE') {
        feeds.directive = '';
        feeds.all = [{
            text: tvTitle,
            url: buildTvUrl({ gamePk, date: dateTime }, tz, gameContext, language)
        }];
    } else {
        feeds.directive = mediaOffText;
        feeds.all = [];
    }

    return feeds;
};

const WatchList = () => {
    const {
        dateTime,
        gamePk,
        gameContext,
        language,
        tv,
        tz,
        partnerBroadcaster,
        blockLoginActivities
    } = useSelector(getMediaLinksState);

    const Tracking = useTracking();
    const translate = useTranslate();
    const { all = [], directive = '' } = getWatchList(tv, tz, gamePk, dateTime, translate, gameContext, language, partnerBroadcaster) || {};
    let content = <></>;

    const handlers = {
        onClick: (e) => {
            const text = e?.currentTarget.innerText || '';
            const cfg = {
                componentName: ['Listen', text],
                selectedIndex: e?.currentTarget?.dataset.index,
                text,
                activity: 'Link Click'
            };

            Tracking.track.track_click(cfg);
        }
    };

    if (directive) {
        content = <NoFeedWrapper>{directive}</NoFeedWrapper>;
    } else if (all?.length > 0) {
        content = all?.map((item, index) => {
            const { text, url } = item;
            const dataAttr = { 'data-index': index };
            return (
                <li key={'watch-list-$' + index}>
                    <Link dataAttr={dataAttr} handlers={handlers} target={'_blank'} url={url} ariaLabel={text}>{text}</Link>
                </li>
            );
        });
    };

    return (
        !blockLoginActivities && <WatchWrapper>
            <div>{ translate('label_watch', 'Watch') }</div>
            <ul>{content}</ul>
        </WatchWrapper>
    );
};

export default WatchList;
